export const isDevHelper = () => {
  const isDev = process.env.NODE_ENV === "development";
  return isDev;
};
